export default class DrivesService {
  constructor() {
    this.tempFolder = {}
    this.folderPath = {}
    this.openedFolder = {}
  }
  updateTempFolder(folderObj) {
    Object.assign(this.tempFolder, folderObj)
  }
  updateFolderPath(folderObj) {
    Object.assign(this.folderPath, folderObj)
  }
  resetFolderPath() {
    this.folderPath = {}
  }
  updateOpenedFolder(folderObj) {
    Object.assign(this.openedFolder, folderObj)
  }
  resetOpenedFolder() {
    this.openedFolder = {}
  }
  updateFolderDataForChangeUser(driveName) {
    this.tempFolder[driveName] = []
    this.folderPath[driveName] = null
    this.openedFolder[driveName] = null
  }
}